import React from 'react'
import DateCell from "@blocks/DateCell";
import { Column } from "react-table";

export default [
    {
        Header: 'Name',
        accessor: row => `${row.user?.first_name} ${row.user?.last_name}`,
        width: "100%"
    },
    {
        Header: 'Sum',
        accessor: 'sum',
        width: 100,
        Cell: ({ row }) => <>€{row.original.sum}</>
    },
    {
        Header: 'Promocode',
        accessor: row => row.clubpromo?.club?.name || row.promo?.code
    },
    {
        Header: 'Method',
        accessor: 'method',
        width: 100,
        Cell: ({ value }) => <span style={{ textTransform: "capitalize"}}>{value}</span>
    },
    {
        Header: 'Date',
        accessor: 'created_at',
        Cell: DateCell
    }
] as Column<Interfaces.Payment>[]